import { render, staticRenderFns } from "./UserHeader.vue?vue&type=template&id=47a0afb4&scoped=true&"
import script from "./UserHeader.vue?vue&type=script&lang=ts&"
export * from "./UserHeader.vue?vue&type=script&lang=ts&"
import style0 from "./UserHeader.vue?vue&type=style&index=0&id=47a0afb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a0afb4",
  null
  
)

export default component.exports